<div class="card">
    <app-header titulo="Usuários" descricao="Área de cadastro dos usuários do sistema"></app-header>

    <app-usuario
    [visivel]="abreUsuarioDialog"
    [usuario]="usuarioSelecionado"
    (fechar)="escondeUsuarioDialog()"
  >
  </app-usuario>

  <a [routerLink]="['novo']"><button
        pButton
        icon="pi pi-user-plus"
        label="Novo Usuário"
      ></button></a>
      <div class="mt-3">
        <p-table [value]="usuarios" class="pb-5" [scrollable]="true" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt [globalFilterFields]="['nomeUsuario','cdUsuarioErp','email']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[1, 20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
          <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton pRipple icon="pi pi-refresh" (click)="carregaUsuarios()"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
            </div>
        </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Usuário ERP</th>
              <th>Ativo</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-usuario
          >
            <tr>
              <td>
                {{ usuario.nomeUsuario }}
              </td>
              <td>
                {{ usuario.email }}
              </td>
              <td>
                {{ usuario.cdUsuarioErp }}
              </td>
              <td>
                <p-tag [value]="usuario.ativo ? 'Ativo' : 'Inativo'" [severity]="usuario.ativo ? 'success' : 'danger'"></p-tag>
              </td>
              <td>
                <a  [routerLink]="['editar',usuario.id]"><p-button
                  
                  icon="pi pi-pencil"
                  [rounded]="true"
                  
                  [text]="true"
                  severity="info"
                  (click)="abreUsuario(usuario)"
                  aria-label="Editar"
                  title="Editar usuário"
                ></p-button>
              </a>
                <p-button
                  *ngIf="usuario.ativo"
                  icon="pi pi-lock"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (click)="desativarUsuario(usuario)"
                  aria-label="Desativar"
                  title="Desativar usuário"
                ></p-button>
                <p-button
                  *ngIf="!usuario.ativo"
                  icon="pi pi-lock-open"
                  [rounded]="true"
                  [text]="true"
                  severity="success"
                  (click)="ativarUsuario(usuario)"
                  aria-label="Ativar"
                  title="Ativar usuário"
                ></p-button>
                <p-button
                                    
                  [rounded]="true"
                  [text]="true"
                  severity="info"
                  (click)="redefinirSenha(usuario, $event)"
                  aria-label="Redefinir"
                  icon="pi pi-refresh"
                  title="Redefinir senha"
                >

              </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <p-confirmDialog />
</div>